import { Builder } from '@builder.io/react'
import { Disclosure } from '@headlessui/react'
import { Amplify, Auth } from 'aws-amplify'
import CdnImage from 'components/util/CdnImage'
import { getCognitoId, getVisitorId, removeCognitoId } from 'components/util/UserId'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateSpoofMode } from 'state/actions/uiAction'
import styled from 'styled-components'
import LinkRoute from '../../ui/link/Link'
import NavbarMenu from '../../ui/navbar/NavbarMenu'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'

import desktopCurveWave from 'images/navbar-curve-desktop.svg'
import mobileCurveWave from 'images/navbar-curve-mobile.svg'

//@ts-ignore
import awsconfig from '../../../aws-exports'
Amplify.configure(awsconfig)

import './index.css'
import { growthbookBuilderVariantUtil } from 'components/util/Growthbook'
import { triggerTagging } from 'components/util/common-utils'
import { pagePriorityOutput } from 'components/util/pagePriorityOutput'
import { Helmet } from 'react-helmet'
import { spoofMode } from 'state/apis/api'
import gtag from 'utils/gtag'
import { getPagePriorityState } from 'utils/priority-storage'

interface Navigation {
  navName: string
  link: string
  items: any
  subCategories: any
  subItems: any
}

interface Props {
  backgroundColor: string
  fontColor: string
  buttonOneProp: LinkButtonProp
  buttonTwoProp: LinkButtonProp
  logo: any
  navigation: Navigation[]
  dropdownColor: string
  showSupportButton: boolean
  showStraightVersion: boolean
}

const StyledHeader = styled.header`
  &::before {
    position: absolute;
    content: '';
    z-index: -1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: ${props => props.backgroundColor};
        ${props =>
          // props.showStraightVersion &&
          `
        -webkit-mask-image: url(${desktopCurveWave});
        -webkit-mask-position: center bottom;
        -webkit-mask-size: 100%;
        -webkit-mask-repeat: no-repeat;
      `}
  }
`

const HeaderWithDropdowns = ({
  navigation,
  logo,
  buttonOneProp,
  buttonTwoProp,
  fontColor,
  backgroundColor,
  dropdownColor,
  showSupportButton,
  showStraightVersion
}: Props) => {
  console.log('Header::Navigations', navigation)
  console.log('Header::ButtonProps', buttonOneProp, buttonTwoProp)
  const [isSignedIn, setIsSignedIn] = useState(false)
  const [showNavBar, setShowNavBar] = useState(true)
  const [_visitorId, setVisitorId] = useState('')
  const [_cognitoId, setCognitoId] = useState('')
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null)
  const [scrollToSection, setScrollToSection] = useState<HTMLElement | null>(null)
  const dispatch = useDispatch()
  const dropdownRef: any = useRef(null)
  const dogDetailsPage = 'dog-details'
  if (buttonOneProp?.buttonUrl) buttonOneProp.buttonUrl = `/signup/${dogDetailsPage}`

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Find the first element with an ID containing "Route"
      const matchingElement = Array.from(document.querySelectorAll<HTMLElement>('[id]')).find(el =>
        el.id.includes('Route')
      )

      if (matchingElement) {
        setScrollToSection(matchingElement as HTMLElement)
      }
    }
  }, [])

  const handleDropdownToggle = (index: any) => {
    setActiveDropdown(activeDropdown === index ? null : index)
  }

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null)
      }
    }
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    let lastScroll: number

    const controlNavbar = () => {
      if (window.scrollY > 100 && window.scrollY >= lastScroll) {
        setShowNavBar(false)
      } else {
        setShowNavBar(true)
      }
      lastScroll = window.scrollY
    }

    window.addEventListener('scroll', controlNavbar)
    return () => {
      window.removeEventListener('scroll', controlNavbar)
    }
  }, [])

  useEffect(() => {
    const checkIfSignedIn = async () => {
      const username = await getCognitoId()
      if (username) {
        setIsSignedIn(true)
      } else {
        setIsSignedIn(false)
      }
    }
    checkIfSignedIn()
  }, [])

  useEffect(() => {
    if (isSignedIn) {
      if (!navigation.some(nav => nav.navName === 'Rewards')) {
        navigation.push({ navName: 'Rewards', link: '/account/rewards' })
      }
    }
  }, [navigation, isSignedIn])

  const handleSignOut = async () => {
    try {
      dispatch(updateSpoofMode(false, '', ''))
      await Auth.signOut()
      setIsSignedIn(false)
      removeCognitoId()
    } catch (err: any) {
      console.log(err, 'error')
    }
  }

  const menuVariant = useMemo(() => growthbookBuilderVariantUtil('mobile-main-menu-icon', [50, 50], true, 1), [])

  const renderDesktopHeaderNavs = () => {
    return navigation.map((navItem, i) => {
      return (
        <div key={i} className="relative">
          {navItem?.items?.length > 0 ? (
            <a
              onClick={e => {
                e.preventDefault()
                handleDropdownToggle(i)
              }}
              className="ml-2 flex justify-center items-center"
            >
              <div
                className={`hover-bg-color:hover text-sm flex flex-row items-center font-sans font-medium hover:bg-white hover:!no-underline focus:!no-underline px-4 py-2 rounded-full ${
                  activeDropdown === i ? 'bg-white' : ''
                }`}
                style={{ color: fontColor }}
                onMouseEnter={() => handleDropdownToggle(i)}
              >
                {navItem.navName}
                {navItem?.items?.length > 0 && (
                  <StaticImage
                    className="ml-2 w-3 h-full"
                    src={'../../../images/checkout/cheveronDown.svg'}
                    alt="Dropdown"
                  />
                )}
              </div>
            </a>
          ) : (
            <LinkRoute
              href={navItem.link}
              className={`hover-bg-color:hover text-sm flex flex-row items-center font-sans font-medium hover:bg-white hover:!no-underline focus:!no-underline px-4 py-2 rounded-full ${
                activeDropdown === i ? 'bg-white' : ''
              }`}
              style={{ color: fontColor }}
              onMouseEnter={() => handleDropdownToggle(i)}
            >
              {navItem.navName}
            </LinkRoute>
          )}
          {activeDropdown === i && (navItem?.items?.length > 0 || navItem?.subCategories?.length > 0) && (
            <div
              className={`absolute top-full ${navItem?.subCategories?.length > 0 ? '-left-[11.5rem]' : 'left-0'} mt-1 p-2 shadow-xl z-10 rounded-2xl flex flex-row w-full sm:w-auto`}
              style={{ backgroundColor: dropdownColor }}
            >
              {/* Items */}
              {navItem.items?.length > 0 && (
                <div className="flex flex-col sm:flex-row w-full">
                  {navItem.items.map((item: any, idx: number) => (
                    <div
                      key={idx}
                      className={`flex flex-col py-2 ${
                        navItem?.items?.length > 0 ? 'justify-start' : 'justify-center'
                      } items-center sm:w-auto`}
                    >
                      <LinkRoute
                        href={item.itemUrl}
                        className="flex flex-col px-2 pt-3 text-sm justify-center text-center overflow-hidden font-sans font-medium hover:!no-underline focus:!no-underline w-[8rem] hover:bg-[#B0CDD5] hover:rounded-2xl hover:pb-2"
                        style={{ color: item.itemColor }}
                      >
                        {item.builderItemImage && (
                          <CdnImage
                            className={`w-full ${item.largerImage ? 'h-32' : 'h-20'} object-cover rounded-xl`}
                            url={item.builderItemImage}
                          />
                        )}
                        {item.itemText}
                      </LinkRoute>
                    </div>
                  ))}
                </div>
              )}

              {/* SubCategories */}
              {navItem.subCategories?.length > 0 && (
                <div className="flex flex-col sm:flex-row w-full sm:w-auto">
                  {navItem.subCategories.map((category: any, categoryIdx: number) => (
                    <div key={categoryIdx} className="flex flex-col px-4 py-2 sm:w-auto">
                      {category.categoryHeading && (
                        <p className="font-sans text-lg font-semibold mb-2 ml-2">{category.categoryHeading}</p>
                      )}
                      {category.subItems.map((subItem: any, subItemIdx: number) => (
                        <div
                          key={subItemIdx}
                          className="flex flex-col pb-2 px-3 justify-center items-start hover:bg-[#B0CDD5] hover:rounded-2xl sm:w-auto"
                        >
                          <LinkRoute
                            href={subItem.itemUrl}
                            className="flex flex-col px-2 pt-2 text-sm justify-center text-center whitespace-nowrap overflow-hidden font-sans font-medium hover:!no-underline focus:!no-underline"
                            style={{ color: subItem.itemColor }}
                          >
                            {subItem.itemText}
                          </LinkRoute>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )
    })
  }

  const sideNavs = renderDesktopHeaderNavs()

  const scrollHandler = () => {
    document.querySelector('#cookiebanner-mask')?.remove()
    document.querySelector('.cookiebanner')?.remove()
  }

  useEffect(() => {
    document.addEventListener('scroll', scrollHandler)

    return () => {
      document.removeEventListener('scroll', scrollHandler)
    }
  }, [])

  useEffect(() => {
    window.onbeforeunload = () => {
      window.scrollTo(0, 0)
    }
  }, [])

  useEffect(() => {
    const callIdsForClarity = async () => {
      setVisitorId(await getVisitorId())
      setCognitoId(await getCognitoId())
    }

    callIdsForClarity()
  }, [])

  const pagePriority = getPagePriorityState(spoofMode)
  const existingUser = pagePriority === 0

  return (
    <>
      <div ref={dropdownRef} className={'header-wrapper'}>
        <Disclosure as="nav" className="relative min-h-[68px] lg:hidden">
          {/* header-fixed */}
          {({ open }) => (
            <div
              className="relative z-30"
              style={{
                transition: 'transform 0.5s ease',
                top: open || showNavBar ? '0px' : '-144px',
                height: open || showNavBar ? 'auto' : '0px',
                transform: 'translateZ(0.1)',
                WebkitMaskImage: showStraightVersion ? '' : `url(${mobileCurveWave})`,
                WebkitMaskPosition: 'center bottom',
                WebkitMaskSize: 'cover'
              }}
            >
              <Helmet
                bodyAttributes={{
                  class: 'content-page'
                }}
              ></Helmet>
              <div
                className="sticky mx-auto px-2 pb-4 pt-2 md:px-6 lg:px-8"
                style={{ backgroundColor: backgroundColor, color: fontColor }}
              >
                <div className="relative flex h-11 items-center justify-between">
                  <div className="inset-y-0 left-0 mr-2 flex items-center lg:hidden">
                    {/* Mobile menu button*/}
                    {!scrollToSection && (
                      <Disclosure.Button
                        className={`inline-flex items-center justify-center rounded-md ${open ? 'p-4' : 'mx-1 p-2'} py-2 focus:outline-none`}
                        onClick={() => {
                          gtag('event', `mobile-menu-icon`, {
                            variation_id: menuVariant,
                            value: open ? 'close' : 'open'
                          })
                        }}
                      >
                        <span className="sr-only">Open main menu</span>
                        {open && (
                          <StaticImage
                            className={`block w-[1.25rem] h-[1.25rem]`}
                            src={'../../../images/navbarCross.svg'}
                            objectFit="contain"
                            alt="Cross"
                          />
                        )}
                        {!open && (
                          <div id="menu" className={`menu-${menuVariant}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        )}
                      </Disclosure.Button>
                    )}
                  </div>
                  <div className="flex flex-1 items-center justify-start sm:items-stretch sm:justify-start mt-2 mr-2 lg:m-0">
                    <div className="flex-shrink-1 flex items-center">
                      <LinkRoute href="/">
                        <img style={{ width: '200px', maxWidth: '100%' }} src={logo} alt="" />
                      </LinkRoute>
                    </div>
                  </div>
                  {!isSignedIn && (
                    <>
                      <>
                        {scrollToSection ? (
                          <button
                            className={`position-create-plan-btn ml-2 inline-block rounded-full border border-transparent bg-white py-2 px-2 font-medium lg:hidden ${open ? 'hidden' : ''}`}
                            style={{
                              backgroundColor: buttonOneProp.buttonColor,
                              color: buttonOneProp.buttonTextColor
                            }}
                            onClick={() => {
                              triggerTagging(
                                `mobile_navbar_cta_create_plan_${scrollToSection.id}`,
                                `${scrollToSection.id}`
                              )
                              scrollToSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                            }}
                          >
                            Get Started
                          </button>
                        ) : (
                          <>
                            <LinkRoute
                              date-testid="signup"
                              href={`/signup/${dogDetailsPage}/`}
                              className={`position-create-plan-btn ml-2 inline-block rounded-full border border-transparent bg-white py-2 px-2 font-medium lg:hidden ${open ? 'hidden' : ''}`}
                              style={{ backgroundColor: 'rgb(0, 102, 133)', color: 'rgb(255, 255, 255)' }}
                              onClick={() => {
                                if (existingUser) {
                                  gtag('event', 'cta_button_click_create_plan', {
                                    page: 'homepage'
                                  })
                                } else {
                                  gtag('event', 'cta_button_click_signup', {
                                    page: 'homepage'
                                  })
                                }
                              }}
                            >
                              Get Started
                            </LinkRoute>
                          </>
                        )}
                      </>
                      <LinkRoute
                        date-testid="signup"
                        href={`/signup/${dogDetailsPage}/`}
                        className={`position-create-plan-btn ml-2 lg:inline-block rounded-full border border-transparent bg-white py-2 px-2 font-medium text-indigo-600 shadow hover:bg-indigo-50 hidden`}
                        style={{ backgroundColor: 'rgb(0, 102, 133)', color: 'rgb(255, 255, 255)' }}
                        onClick={() => {
                          gtag('event', 'cta_button_click', {
                            page: 'homepage'
                          })
                        }}
                      >
                        Create Plan
                      </LinkRoute>
                    </>
                  )}
                </div>
              </div>

              <Disclosure.Panel className="lg:hidden">
                <div className="space-y-1 px-2 pt-2 pb-3" style={{ backgroundColor }}>
                  {navigation.map((navItem, i) => (
                    <div
                      key={i}
                      className={`relative flex flex-col w-full ${navItem?.items?.length > 0 || navItem?.subCategories?.length > 0 ? '!-mb-4' : ''} ${
                        activeDropdown === i ? '!mb-0' : ''
                      } `}
                    >
                      <div className="flex flex-row justify-between items-center w-full">
                        {navItem?.items?.length > 0 || navItem?.subCategories?.length > 0 ? (
                          <a
                            onClick={e => {
                              e.preventDefault()
                              handleDropdownToggle(i)
                            }}
                            className="flex items-center"
                          >
                            <div
                              className={`flex flex-row items-center ${activeDropdown === i ? 'bg-white rounded-t-2xl hover:bg-white hover:rounded-t-2xl' : 'hover:rounded-2xl'} hover:bg-white px-3 py-2 text-base font-medium no-underline`}
                              style={{ color: fontColor }}
                            >
                              {navItem.navName}
                              {(navItem?.items?.length > 0 || navItem?.subCategories?.length > 0) && (
                                <StaticImage
                                  className={`ml-2 w-4 h-auto transition-transform duration-300 ${activeDropdown === i ? 'rotate-180' : ''}`}
                                  src={'../../../images/checkout/cheveronDown.svg'}
                                  alt="Dropdown"
                                />
                              )}
                            </div>
                          </a>
                        ) : (
                          <LinkRoute
                            href={navItem.link}
                            className={`flex flex-row items-center ${activeDropdown === i ? 'bg-white rounded-t-2xl hover:bg-white hover:rounded-t-2xl' : 'hover:rounded-2xl'} hover:bg-white px-3 py-2 text-base font-medium no-underline`}
                            style={{ color: fontColor }}
                          >
                            {navItem.navName}
                          </LinkRoute>
                        )}
                      </div>
                      <div
                        className={`!transition-all !ease-in-out !duration-1000 overflow-hidden ${
                          activeDropdown === i ? 'h-auto opacity-100 visible' : 'opacity-0 invisible'
                        } ${navItem?.items?.length === 0 || navItem?.subCategories?.length === 0 ? 'hidden' : 'pb-3'} 
    w-full z-10 rounded-b-2xl rounded-r-2xl grid grid-cols-2 gap-1 mx-auto justify-center items-start`}
                        style={{ backgroundColor: dropdownColor }}
                      >
                        {activeDropdown === i && (navItem?.items?.length > 0 || navItem?.subCategories?.length > 0) && (
                          <>
                            {/* Items */}
                            {navItem.items.map((item: any, idx: number) => (
                              <div
                                key={idx}
                                className="flex flex-col p-2 justify-center items-center hover:bg-[#B0CDD5] hover:rounded-2xl"
                              >
                                <LinkRoute
                                  href={item.itemUrl}
                                  className="flex flex-col justify-center items-center text-sm text-center whitespace-nowrap overflow-hidden font-sans font-medium"
                                  style={{ color: item.itemColor }}
                                >
                                  {item.builderItemImage && (
                                    <CdnImage
                                      className="w-56 h-24 object-cover rounded-xl"
                                      url={item.builderItemImage}
                                    />
                                  )}
                                  {item.itemText}
                                </LinkRoute>
                              </div>
                            ))}
                            {/* SubCategories */}
                            {navItem.subCategories?.map((category: any, categoryIdx: number) => (
                              <div key={categoryIdx} className="flex flex-col p-2 pl-0">
                                <p className="font-sans text-lg font-semibold mb-2 ml-2">{category.categoryHeading}</p>
                                <div className="grid grid-cols-1 gap-2">
                                  {category.subItems.map((subItem: any, subItemIdx: number) => (
                                    <div
                                      key={subItemIdx}
                                      className="flex flex-col justify-center items-start hover:bg-[#B0CDD5] hover:rounded-2xl"
                                    >
                                      <LinkRoute
                                        href={subItem.itemUrl}
                                        className="flex flex-col px-2 pt-2 text-sm text-center whitespace-nowrap overflow-hidden font-sans font-medium hover:!no-underline focus:!no-underline"
                                        style={{ color: subItem.itemColor }}
                                      >
                                        {subItem.itemText}
                                      </LinkRoute>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  ))}

                  {isSignedIn ? (
                    <>
                      <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-row w-[94%] items-center justify-center mb-4">
                          {showSupportButton && (
                            <div
                              className={`mr-2 lg:hidden flex-shrink-0 cursor-pointer rounded-full py-[0.4rem] text-base flex flex-row border-2 border-[#006685] w-[48%] justify-center items-center font-sans font-medium`}
                              onClick={() => {
                                if (typeof window.zE !== 'undefined') {
                                  window.zE('webWidget', 'show')
                                  window.zE('webWidget', 'open')
                                } else {
                                  window.setTimeout(() => {
                                    window.zE('webWidget', 'show')
                                    window.zE('webWidget', 'open')
                                  }, 1000)
                                }
                              }}
                            >
                              <StaticImage
                                width={20}
                                className="flex flex-shrink-0 mr-2"
                                src="../../../images/chat.png"
                                alt="Chat with us"
                              />{' '}
                              Support
                            </div>
                          )}
                          <div className="flex flex-row items-center justify-center w-full mx-auto">
                            <LinkRoute
                              href={'/account'}
                              className={`inline-block text-center bg-white py-2 px-2 ml-2 border-transparent rounded-full font-medium text-base w-11/12 items-center justify-center border-2 border-[#006685]`}
                            >
                              <StaticImage className="w-6 h-6 mr-3" src="../../../images/login.svg" alt="Login" />
                              Account
                            </LinkRoute>
                          </div>
                        </div>
                      </div>
                      <div className="flex w-full items-center justify-center">
                        <button
                          type="button"
                          className="inline-block underline pb-4 px-2 text-sm font-medium text-base"
                          onClick={handleSignOut}
                        >
                          Sign out
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="flex flex-col w-full items-center justify-center">
                      <div className="flex w-full items-center justify-center mx-auto py-2">
                        <>
                          {scrollToSection ? (
                            <Disclosure.Button
                              className={`inline-block text-center bg-white py-2 px-2 border border-transparent rounded-full font-medium w-[94%]`}
                              style={{
                                backgroundColor: buttonOneProp.buttonColor,
                                color: buttonOneProp.buttonTextColor
                              }}
                              onClick={() => {
                                triggerTagging(
                                  `dropdown_navbar_cta_create_plan_${scrollToSection.id}`,
                                  `${scrollToSection.id}`
                                )
                                scrollToSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                setShowNavBar(false)
                              }}
                            >
                              {scrollToSection
                                ? 'Get Started'
                                : isSignedIn
                                  ? buttonOneProp?.loggedInButtonText
                                  : buttonOneProp?.buttonText}
                            </Disclosure.Button>
                          ) : (
                            <>
                              <LinkButton
                                {...buttonOneProp}
                                isLink={false}
                                classList={`inline-block text-center bg-white py-2 px-2 border border-transparent rounded-full font-medium w-[94%]`}
                                onClick={() => {
                                  gtag('event', 'cta_button_click', {
                                    page: 'homepage'
                                  })
                                }}
                              />
                            </>
                          )}
                        </>
                      </div>
                      <div className="flex flex-row w-[94%] items-center justify-center mb-4">
                        {showSupportButton && (
                          <div
                            className={`mr-2 lg:hidden flex-shrink-0 cursor-pointer rounded-full py-[0.4rem] text-base flex flex-row border-2 border-[#006685] w-[48%] justify-center items-center font-sans font-medium`}
                            onClick={() => {
                              if (typeof window.zE !== 'undefined') {
                                window.zE('webWidget', 'show')
                                window.zE('webWidget', 'open')
                              } else {
                                window.setTimeout(() => {
                                  window.zE('webWidget', 'show')
                                  window.zE('webWidget', 'open')
                                }, 1000)
                              }
                            }}
                          >
                            <StaticImage
                              width={20}
                              className="flex flex-shrink-0 mr-2"
                              src="../../../images/chat.png"
                              alt="Chat with us"
                            />{' '}
                            Support
                          </div>
                        )}
                        <div className="flex flex-row items-center justify-center w-full mx-auto">
                          <LinkButton
                            {...buttonTwoProp}
                            isLink={false}
                            classList={`inline-block text-center bg-white py-2 px-2 ml-2 border border-transparent rounded-full font-medium text-indigo-600 hover:bg-indigo-50 shadow w-11/12 flex items-center justify-center border-2 border-[#006685]`}
                            onClick={() => {
                              gtag('event', 'cta_navbar_sign_in_button_click', {
                                page: 'homepage'
                              })
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
        <StyledHeader
          backgroundColor={backgroundColor}
          className={`relative mt-0 hidden ${showStraightVersion ? 'min-h-[94px]' : 'min-h-[100px] lg:min-h-[115px]'} lg:block`}
          style={{
            color: fontColor,
            transition: 'top 0.5s',
            top: showNavBar ? '-1.7rem' : '-164px',
            height: showNavBar ? '' : '0px',
            transform: 'translateZ(0.1)',
            zIndex: 3
          }}
        >
          <nav
            className="max-w-7 mx-auto"
            style={{ backgroundColor: backgroundColor ? backgroundColor : 'bg-[#F6E9DB]' }}
            aria-label="Top"
          >
            <div
              className={`flex w-full items-center ${isSignedIn ? 'pt-12' : 'pt-8'} ${showStraightVersion ? 'pb-2' : ''} px-6`}
            >
              <div>
                <LinkRoute href="/">
                  <span className="sr-only">Different Dog</span>
                  <img style={{ width: '200px', maxWidth: '100%' }} src={logo} alt="" />
                </LinkRoute>
              </div>
              {isSignedIn ? (
                <div className="flex w-full items-center justify-center">
                  <div
                    className={`flex items-center justify-center ${navigation.some(nav => nav.navName === 'Rewards') ? 'mr-44' : 'mr-40'}`}
                  >
                    <div className="flex items-center font-serif text-sm">{sideNavs}</div>
                  </div>

                  <div className="absolute right-0 flex items-center">
                    <div
                      className="mx-2 hidden flex-shrink-0 cursor-pointer rounded-full p-4 text-sm hover:bg-[white] focus:bg-[white] sm:flex"
                      onClick={() => {
                        if (typeof window.zE !== 'undefined') {
                          window.zE('webWidget', 'show')
                          window.zE('webWidget', 'open')
                        } else {
                          window.setTimeout(() => {
                            window.zE('webWidget', 'show')
                            window.zE('webWidget', 'open')
                          }, 1000)
                        }
                      }}
                    >
                      <StaticImage
                        width={30}
                        className="flex flex-shrink-0"
                        src="../../../images/chat.png"
                        alt="Chat with us"
                      />
                    </div>
                    <NavbarMenu isLogin={isSignedIn} handleSignOut={handleSignOut} />
                  </div>
                </div>
              ) : (
                <div className="flex w-full items-center justify-end">
                  <div className={`flex w-full justify-center ${!isSignedIn ? 'ml-0' : 'ml-16'}`}>
                    <div className={`flex items-center justify-end font-serif text-sm`}>{sideNavs}</div>
                  </div>
                  <div className="flex flex-shrink-0">
                    <>
                      {scrollToSection ? (
                        <button
                          className={`inline-block text-center bg-[#006685] text-white py-2 px-2 border border-transparent rounded-full font-medium`}
                          style={{ backgroundColor: buttonOneProp.buttonColor, color: buttonOneProp.buttonTextColor }}
                          onClick={() => {
                            triggerTagging(
                              `desktop_navbar_cta_create_plan_${scrollToSection.id}`,
                              `${scrollToSection.id}`
                            )
                            scrollToSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                          }}
                        >
                          {scrollToSection
                            ? 'Get Started'
                            : isSignedIn
                              ? buttonOneProp?.loggedInButtonText
                              : buttonOneProp?.buttonText}
                        </button>
                      ) : (
                        <>
                          <LinkButton
                            {...buttonOneProp}
                            isLink={false}
                            classList={`inline-block text-center bg-white py-2 px-2 border border-transparent rounded-full font-medium`}
                            onClick={() => {
                              gtag('event', 'cta_button_click_signup', {
                                page: 'homepage'
                              })
                            }}
                          />
                        </>
                      )}
                    </>
                  </div>
                  <div
                    className={`ml-2 -mr-2 hidden flex-shrink-0 cursor-pointer rounded-full p-4 text-sm hover:bg-[white] focus:bg-[white] sm:flex`}
                    onClick={() => {
                      if (typeof window.zE !== 'undefined') {
                        window.zE('webWidget', 'show')
                        window.zE('webWidget', 'open')
                      } else {
                        window.setTimeout(() => {
                          window.zE('webWidget', 'show')
                          window.zE('webWidget', 'open')
                        }, 1000)
                      }
                    }}
                  >
                    <StaticImage
                      width={30}
                      className="flex flex-shrink-0"
                      src="../../../images/chat.png"
                      alt="Chat with us"
                    />
                  </div>
                  <div className="flex flex-shrink-0">
                    <LinkButton
                      {...buttonTwoProp}
                      buttonColor={'transparent'}
                      isLink={false}
                      classList={`inline-flex w-full justify-center rounded-full p-4 text-sm hover:!bg-white focus:!bg-white`}
                      onClick={() => {
                        gtag('event', 'header_button_click_account', {
                          page: 'homepage'
                        })
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </nav>
        </StyledHeader>
      </div>
    </>
  )
}

export default HeaderWithDropdowns

Builder.registerComponent(HeaderWithDropdowns, {
  name: 'HeaderWithDropdowns',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'logo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'navigation',
      type: 'list',
      defaultValue: [
        {
          navName: 'About',
          link: '#',
          items: [{ itemText: 'Marketing', itemUrl: '#', itemColor: 'gray' }]
        }
      ],
      subFields: [
        { name: 'navName', type: 'string', defaultValue: 'About' },
        { name: 'link', type: 'string', defaultValue: '#' },
        {
          name: 'items',
          type: 'list',
          subFields: [
            { name: 'itemText', type: 'string', defaultValue: 'Marketing' },
            { name: 'itemUrl', type: 'string', defaultValue: '#' },
            { name: 'itemColor', type: 'color', defaultValue: 'gray' },
            {
              name: 'builderItemImage',
              type: 'file',
              allowedFileTypes: ['jpeg', 'png', 'svg']
            },
            {
              name: 'largerImage',
              type: 'boolean',
              defaultValue: false
            }
          ],
          defaultValue: [{ itemText: 'Marketing', itemUrl: '#', itemColor: 'gray' }]
        },
        {
          name: 'subCategories',
          type: 'list',
          subFields: [
            { name: 'categoryHeading', type: 'string', defaultValue: 'Category Heading' },
            {
              name: 'subItems',
              type: 'list',
              subFields: [
                { name: 'itemText', type: 'string', defaultValue: 'Sub-item Text' },
                { name: 'itemUrl', type: 'string', defaultValue: '#' },
                { name: 'itemColor', type: 'color', defaultValue: 'gray' }
              ],
              defaultValue: [{ itemText: 'Sub-item Text', itemUrl: '#', itemColor: 'gray' }]
            }
          ]
        }
      ]
    },

    {
      name: 'dropdownColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOneProp'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonTwoProp'
    },
    {
      name: 'showSupportButton',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'showStraightVersion',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
